import { render, staticRenderFns } from "./RelatorioTaxasParcelas.vue?vue&type=template&id=d369d7a4"
import script from "./RelatorioTaxasParcelas.vue?vue&type=script&lang=js"
export * from "./RelatorioTaxasParcelas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports